import axios from "axios";

function requestLogin(member) {
  const form = new FormData();
  form.append("username", member.id);
  form.append("password", member.memberPw);
  form.append("grant_type", "password");
  const requestData = {
    url: `${process.env.VUE_APP_BASEURL}/oauth/token`,
    method: "POST",
    auth: {
      username: process.env.VUE_APP_CLIENTID,
      password: process.env.VUE_APP_CLIENTSECRET
    },
    data: form
  };
  return axios(requestData);
}

function requestMemberDetail() {
  return axios.get(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-detail`
  );
}

function requestMemberClickDetail(memberId) {
  return axios.get(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-click-detail?id=${memberId}`
  );
}

function requestMemberList(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-page`,
    parameter
  );
}

function requestMemberEventUpdate(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-event-update`,
    parameter
  );
}

function requestMemberInfoUpdate(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-info-update`,
    parameter
  );
}
function requestMEventList() {
  return axios.get(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/event-list`
  );
}

function requestMEventRegiste(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-event-regist?id=${parameter.memberId}`,
    parameter.item
  );
}

function requestMEventDelete(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/admin/members/member-event-delete`,
    parameter
  );
}

function requestMemberCorpUpdate(parameter) {
  return axios.get(
    `${process.env.VUE_APP_BASEURL}/api/app/members/corp-update?corpId=${parameter.corpCodeId}`
  );
}
function requestSessionMember(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/members/session`,
    parameter.member
  );
}

function requestChangeMarketAgreeMember(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/members/changeMarketing`,
    parameter.member
  );
}
export {
  requestLogin,
  requestMemberDetail,
  requestMemberList,
  requestMemberClickDetail,
  requestMemberEventUpdate,
  requestMemberInfoUpdate,
  requestMEventList,
  requestMEventRegiste,
  requestMEventDelete,
  requestMemberCorpUpdate,
  requestSessionMember,
  requestChangeMarketAgreeMember
};
